import { CJEvent } from 'types/event';

export function isCJEventInformationsEmpty(cjEvent: CJEvent) {
  const {
    bo: { domaine = [], goals = [], competence = [], matiere = [] },
    materials = [],
    customFields = [],
  } = cjEvent;
  return (
    domaine.length === 0 &&
    goals.length === 0 &&
    competence.length === 0 &&
    materials.length === 0 &&
    customFields.length === 0 &&
    matiere.length === 0
  );
}
